import type { ReactElement } from 'react';

import type { PartnersItemAttributes } from 'hb-react/backoffice/types/builder/itemAttributes/partnersItemAttributes';
import Grid, { Row } from 'hb-react/shared/components/DesignSystem/Grid';

const PartnersGridUI = ({
  attributes,
  children,
}: {
  attributes?: PartnersItemAttributes;
  children: ReactElement;
}) => (
  <Grid columnsInMobile p={attributes?.containerPadding} mx={0} width="100%">
    <Row justifyCenter>{children}</Row>
  </Grid>
);

export default PartnersGridUI;
